import styled from 'styled-components';

export const AdminContainer = styled.main`
  width: 100%;
  min-height: 100vh;
  display: flex;
  /* border: 2px solid red; */
`;

export const LeftAdmin = styled.aside`
  width: 30%;
  padding-top: ${({ theme }) => theme.spacing.l};
  padding-inline: ${({ theme }) => theme.spacing.l};
  /* border: 5px solid orange; */
  background-color: ${({ theme }) => theme.colors.grey6};
  @media screen and (max-width: 768px) {
    width: 100%;
    padding: ${({ theme }) => theme.spacing.s};
  }
`;
export const TopLeftAdmin = styled.div`
  border-bottom: 3px solid ${({ theme }) => theme.colors.yellow3};
  margin-bottom: ${({ theme }) => theme.spacing.s};
  padding-bottom: ${({ theme }) => theme.spacing.xs};
  /* text-align: center; */
  /* min-height: 80px; adjust as needed */
  /* border: 1px solid blue; */
  h2 {
    color: ${({ theme }) => theme.colors.grey1};
    text-transform: capitalize;
    font-size: ${({ theme }) => theme.spacing.l};
    /* text-align: center; */
    /* padding: ${({ theme }) => theme.spacing.s}; */
    transition: all 0.3s ease-in-out;
  }
  h2::after {
    width: 0;
  }
  h4 {
    /* border: 1px solid red; */
    font-style: italic;
    color: ${({ theme }) => theme.colors.grey2};
    font-size: 1rem;
    /* margin-bottom: ${({ theme }) => theme.spacing.s}; */
  }
`;

export const BottomLeftAdmin = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.s};
  a {
    color: ${({ theme }) => theme.colors.grey1};
    margin-block: ${({ theme }) => theme.spacing.xxs};
    transition: color 0.3s ease-in-out;
  }
  a:hover {
    color: ${({ theme }) => theme.colors.orange2};
    transform: scale(1.05);
  }
  .menuCategory {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    /* background: linear-gradient(
      90deg,
      ${({ theme }) => theme.colors.grey6},
      ${({ theme }) => theme.colors.grey4}
    ); */
    background-color: ${({ theme }) => theme.colors.grey5};
    padding: ${({ theme }) => theme.spacing.s};
    border-radius: 8px;
    margin-bottom: ${({ theme }) => theme.spacing.xs};
    transition: all 0.3s ease-in-out;
    &:hover {
      background-color: ${({ theme }) => theme.colors.grey4};
      transform: scale(1.05);
    }
  }
  .menuCategory h4 {
    color: ${({ theme }) => theme.colors.grey1};
    font-size: ${({ theme }) => theme.spacing.m};
  }
`;

export const RightAdmin = styled.section`
  width: 70%;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.offWhite};
  /* border: 3px solid green; */
`;

export const AdminTabs = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.m};
  /* padding-block: ${({ theme }) => theme.spacing.m}; */
  /* border: 1px solid pink; */
  padding-left: ${({ theme }) => theme.spacing.l};
  padding-top: ${({ theme }) => theme.spacing.l};
  background-color: ${({ theme }) => theme.colors.grey5};
`;

export const AdminTable = styled.div`
  /* border: 1px solid blue; */
  padding: ${({ theme }) => theme.spacing.l};
  /* overflow-y: scroll; */
`;

export const InsideSearch = styled.div`
  /* border: 1px solid green; */
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s};
  input {
    width: 40%;
  }
  button {
    width: auto;
  }
  @media screen and (max-width: 768px) {
    input {
      width: 65%;
    }
    button {
      width: 30%;
    }
    display: flex;
    flex-wrap: nowrap;
  }
`;

export const MobileAdminDataContainer = styled.main`
  @media screen and (max-width: 768px) {
    height: 100%;
    /* border: 1px solid red; */
    background-color: ${({ theme }) => theme.colors.offWhite};
    padding-block: ${({ theme }) => theme.spacing.s};
    padding-inline: ${({ theme }) => theme.spacing.l};
  }
`;
